// ファイル名を取得して表示する
const getFileInfo = () => {
  const fileText1 = document.getElementById('p-contact__fileText1');
  const fileText2 = document.getElementById('p-contact__fileText2');
  const file1 = document.getElementById('p-contact__file1');
  const file2 = document.getElementById('p-contact__file2');
  const setChangeEvt = (f, t) => {
    f.addEventListener('change', e => {
      let files = e.target.files;
      if (files[0]) {
        t.innerText = files[0].name;
      }
    });
  };
  if (file1 && file2) {
    setChangeEvt(file1, fileText1);
    setChangeEvt(file2, fileText2);
  }
};
getFileInfo();


/**
 * client
 */
'use strict';

import Gnav from './_modules/common/Gnav';
import PageTransition from './_modules/common/PageTransition';

let main = [];

/**
 * DOMContentLoaded
 */
document.addEventListener('DOMContentLoaded', () => {
  new Gnav();
  main['PageTransition'] = new PageTransition();
}, false);

/**
 * window.onload
 */
window.addEventListener('load', () => {
  main['PageTransition'].start();
}, false);

/**
 * window.unload（念のため）
 */
window.addEventListener('unload', () => {}, false);

